import queryString from 'query-string';
import { getUserCurrentStore } from 'utils/auth';
import { reportsApi } from 'utils/api/baas/reports/axiosBase';

export interface RequestProps {
  page: number;
  pageSize: number;
  startDate?: string;
  endDate?: string;
  state?: string;
  cashSessionUuid?: string;
}

export async function getCashRegisterSessions(params: RequestProps) {
  const store = getUserCurrentStore()?.uuid;
  const response = await reportsApi.get(`/v2/reports/cash-register-sessions/`, {
    params: {
      page: params.page,
      page_size: params.pageSize,
      store_uuid: store,
      start_date: params.startDate,
      end_date: params.endDate,
      state: params?.state,
      cash_session_uuid: params?.cashSessionUuid,
    },
    paramsSerializer: (p) => queryString.stringify(p, { arrayFormat: 'comma' }),
  });
  return response.data;
}

export async function getDailySettlement(params: RequestProps) {
  const store = getUserCurrentStore()?.uuid;
  const response = await reportsApi.get(`/v2/reports/cash-sessions/`, {
    params: {
      page: params.page,
      page_size: params.pageSize,
      store_uuid: store,
      start_date: params.startDate,
      end_date: params.endDate,
    },
    paramsSerializer: (p) => queryString.stringify(p, { arrayFormat: 'comma' }),
  });
  return response.data;
}

export async function getDailySettlementDetails(cashSessionUuid: string) {
  const store = getUserCurrentStore()?.uuid;
  const response = await reportsApi.get(`/v2/reports/cash-sessions/${cashSessionUuid}?store_uuid=${store}`, {
    paramsSerializer: (p) => queryString.stringify(p, { arrayFormat: 'comma' }),
  });
  return response.data;
}
